import { useContext, useState } from 'react'
import { AppContext } from './AppContext'
import CommonAPIs from '../controller/API/CommonAPIs'
import Constant from '../controller/Constant'
import moment from 'moment'
import { RenderTrainedInfoItemType } from '../types'

const useRenderHistory = () => {
  const { isSpinning, setIsSpinning, showErrorApiAlert, setMenuSelected } = useContext(AppContext)
  const [renderList, setRenderList] = useState<RenderTrainedInfoItemType[]>([])
  const [schedule, setSchedule] = useState<{
    startTime: Date | string
    endTime: Date | string
  }>({
    startTime: moment().subtract(6, 'days').toDate(),
    endTime: new Date()
  })
  const [imgTypeSelected, setImgTypeSelected] = useState({
    type: 0,
    name: 'すべて種類'
  })
  const [renderProcessingList, setRenderProcessingList] = useState<RenderTrainedInfoItemType[]>([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)

  const getRenderHistoryList = () => {
    setIsSpinning(true)
    CommonAPIs.getRenderHistory(schedule.startTime, schedule.endTime, currentPage)
      .then((res) => {
        console.log('history:', res)
        setRenderList(res?.data)
        setTotalPages(res?.meta.last_page)
      })
      .finally(() => setIsSpinning(false))
  }

  const getRenderProcessing = () => {
    const renderProcessingStorageAmount = localStorage.getItem('renderProcessingAmount') ?? 0
    CommonAPIs.getRenderProcessing()
      .then((res) => {
        console.log('processing:', res)
         
        // get list processing id
        let newProcessingIds = res.map((item: RenderTrainedInfoItemType) => item.id)

        // check and get different ids between processingIds and newProcessingIds array
        let processingIds = localStorage.getItem('processingIds') ? JSON.parse(localStorage.getItem('processingIds') ?? '[]') : []
        let diffIds = processingIds.filter((id: number) => !newProcessingIds.includes(id))

        // if diffIds is not empty, call api get status by id
        if (diffIds.length > 0) {
          diffIds.forEach((id: number) => {
            CommonAPIs.renderImg2ImgJob(id)
              .then((res) => {
                if (res?.status == Constant.processing.FAIL) {
                  showErrorApiAlert('イメージの作成に失敗しました。もう一度お試しください。', 5000)
                }
              })
              .catch((err) => showErrorApiAlert(err))
          })
        }

        // set newProcessingIds to processingIds 
        localStorage.setItem('processingIds', JSON.stringify(newProcessingIds))
        //setProcessingIds(newProcessingIds)
  
        if (renderProcessingStorageAmount && Number(renderProcessingStorageAmount) > res?.length) {
          getRenderHistoryList()
        }
        let newDt = res.filter((item: RenderTrainedInfoItemType) => {
          const createdAt = moment(item.updated_at ?? new Date())
          const startDate = moment(schedule.startTime)
          const endDate = moment(schedule.endTime)
          return createdAt.isBetween(startDate, endDate, 'days', '[]')
        })
        setRenderProcessingList(newDt)
        localStorage.setItem('renderProcessingAmount', res?.length)
      })
      .catch((err) => showErrorApiAlert(err))
  }

  const onChangePage = (page: any) => {
    setCurrentPage(page)
    window.scrollTo(0, 0)
  }

  const handleFilter = () => {
    getRenderHistoryList()
    getRenderProcessing()
  }
  return {
    getRenderHistoryList,
    getRenderProcessing,
    handleFilter,
    schedule,
    setSchedule,
    imgTypeSelected,
    setImgTypeSelected,
    renderProcessingList,
    isSpinning,
    renderList,
    totalPages,
    onChangePage,
    currentPage,
    setRenderProcessingList
  }
}

export default useRenderHistory
